<template>
  <div class="panel-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="iconList"/>
          </span>
          <div>
            <h1 class="pl-card__title">خصوصیات</h1>
            <p class="pl-card__sub">مدیریت خصوصیات و ویژگی‌های محصول</p>
          </div>
        </div>
        <div class="pl-toolbar">
          <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
            <CIcon name="iconPlus"/>
            <span>افزودن خصوصیت</span>
          </button>
        </div>
      </div>

      <div class="pl-card__body">
        <CDataTableFixed
          class="pl-table"
          :items="items"
          :fields="fields"
          :items-per-page="20"
          hover
          sorter
          pagination
          :noItemsView="{ noItems: 'خصوصیتی یافت نشد' }"
        >
          <template #no-items-view>
            <div class="pl-empty">
              <span class="pl-empty__icon" aria-hidden="true">
                <CIcon name="iconList"/>
              </span>
              <p class="pl-empty__title">خصوصیتی یافت نشد</p>
              <p class="pl-empty__sub">برای شروع، یک خصوصیت جدید اضافه کنید.</p>
              <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
                <CIcon name="iconPlus"/>
                <span>افزودن خصوصیت</span>
              </button>
            </div>
          </template>

          <template #row="{ item }">
            <td>
              <span class="pl-muted">{{ item.row_id + 1 }}</span>
            </td>
          </template>

          <template #نام="{ item }">
            <td>
              <span class="pl-name" v-if="item.title != null">{{ item.title.title }}</span>
            </td>
          </template>

          <template #code="{ item }">
            <td>
              <span class="pl-muted">{{ item.code }}</span>
            </td>
          </template>

          <template #priority="{ item }">
            <td>
              <span class="pl-muted">{{ item.priority }}</span>
            </td>
          </template>

          <template #عملیات="{ item }">
            <td class="pl-ops-cell">
              <div class="pl-ops">
                <button
                  type="button"
                  class="pl-btn pl-btn--sm pl-btn--ghost"
                  title="مقادیر خصوصیات"
                  @click="goSubCategories(item)"
                >
                  <CIcon name="iconList"/>
                  <span>مقادیر خصوصیات</span>
                </button>
                <button type="button" class="pl-icon-btn pl-icon-btn--warn" title="ویرایش" @click="openEditModal(item)">
                  <CIcon name="iconEdit"/>
                </button>
                <button type="button" class="pl-icon-btn pl-icon-btn--danger" title="حذف" @click="delete_dialog(item)">
                  <CIcon name="iconTrash"/>
                </button>
              </div>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </div>

    <CModal
      :show.sync="form_modal"
      :centered="true"
      size="lg"
      :title="status_form == 0 ? 'ثبت خصوصیت' : 'ویرایش خصوصیت'"
      @update:show="onFormModalToggle"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12" md="6">
            <CInput
              v-model="name"
              class="required"
              label="نام خصوصیت"
            />
          </CCol>
          <CCol col="12" md="6">
            <CInput
              v-model="code"
              class="required"
              label="کد خصوصیت"
            />
          </CCol>
          <CCol col="12" md="6">
            <CInput
              v-model="priority"
              label="اولویت"
            />
          </CCol>
          <CCol col="12">
            <div class="control_wrapper">
              <div class="required">
                <label>دسته بندی</label>
              </div>
              <treeselect
                v-model="value_category"
                :multiple="true"
                :normalizer="normalizer_category"
                :append-to-body="true"
                :options="options_category"
                placeholder="دسته بندی محصول را انتخاب کنید"
              />
            </div>
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="closeFormModal()">انصراف</button>
        <button type="button" class="pl-btn pl-btn--primary" @click="login()">
          <CIcon name="iconCheck"/>
          <span>{{ status_form == 0 ? 'ثبت خصوصیت' : 'ذخیره تغییرات' }}</span>
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from "../../../main";

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'Login',
  components: {
    Treeselect,
  },
  data() {
    return {
      form_modal: false,
      confirm_delete_name: new Date().getTime() + "_" + this.$vnode.tag,
      priority: '1',
      name: '',
      file: '',
      code: '',
      previewImage: '',
      description: '',
      items: [],
      fields: [
        {key: 'row', label: '#', _style: 'width:3%'},
        {key: 'نام', _style: 'width:20%'},
        {key: 'code', label: 'کد', _style: 'width:10%'},
        {key: 'priority', label: 'اولویت', _style: 'width:20%'},
        {key: 'عملیات', _style: 'width:30%;'},
      ],
      options_category: [],
      value_category: [],
      normalizer_category(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        }
      },
      status_form: 0
    }
  },
  mounted() {
    bus.$on(this.confirm_delete_name, (data) => {
      if (data == 'true') {
        this.delete_item();
      } else {
        this.status_form = 0;
      }
    });
    this.get_data();
    this.get_categories();
  },
  watch: {},
  methods: {
    openCreateModal() {
      this.cancel_form();
      this.form_modal = true;
    },
    openEditModal(item) {
      this.editDetails(item);
      this.form_modal = true;
    },
    closeFormModal() {
      this.form_modal = false;
      this.cancel_form();
    },
    onFormModalToggle(show) {
      if (!show) {
        this.cancel_form();
      }
    },
    editDetails(item) {
      var self = this;
      this.name = item.title.title;
      this.code = item.code;
      this.priority = item.priority;
      this.value_category = []
      item.categories.forEach(function (val) {
        self.value_category.push(val.category_id)
      })
      this.status_form = item.id;
    },
    cancel_form() {
      this.name = ''
      this.code = ''
      this.priority = '1'
      this.value_category = []
      this.status_form = 0
    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_categories_with_children', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.options_category = content_cats.orders;
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    get_data() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_bundles', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.items = content_cats.tags.map((item, row_id) => {
          return {...item, row_id}
        });
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    goSubCategories(item) {
      this.$router.push({path: '/dashboard/products/bundle-items/' + item.id});
    },
    login() {
      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/product/add_bundle";
      } else {
        url = "/api/admin/product/update_bundle";
        formData.append('id', this.status_form)
      }

      formData.append('name', this.name);
      formData.append('code', this.code);
      formData.append('priority', this.priority);
      formData.append('cat_list', this.value_category);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.form_modal = false;
        self.status_form = 0;
        self.name = '';
        self.code = '';
        self.priority = '1';
        self.value_category = [];
        self.get_data();
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    delete_dialog(item) {
      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);
      this.status_form = item.id;
    },
    delete_item() {
      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_bundle";

      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;
        self.get_data();
      })
        .catch(function (error) {
          console.log(error);
        });
    },
  }
}
</script>
